export default __webpack_public_path__ + "static/principles-of-use-dont-light-0d59f24ffb4bedd49ac582251b411411.png";